import * as Config from '@/config'
import {PF_BASE_URL} from "@/config";

export default function Header() {
  return (
    <header>
      <a href={PF_BASE_URL}><img src={require('../assets/images/drm-pf-logo.png')} alt="drm-pf-logo"/></a>
      <p className="uk-margin-remove-vertical header-company-text">DRM-PFポータルサイト</p>
      {Config.HEADER_ENV !== "" &&
          <span className="uk-margin-small-left env-label uk-text-medium-s">{Config.HEADER_ENV}</span>}
    </header>
  );
}